import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  IdRanking?: string;
  queryKey?: string;
  CodigoCargo?: string;
  PaginaAtual?: number;
  TotalItensRetorno?: number;
  PalavraChave?: string;
}
export function useGetDestaquesDetalhes(props: Props) {
  const hasIdRanking = props.IdRanking ? `&IdRanking=${props.IdRanking}` : "";
  const hasCargo = props.CodigoCargo ? `&CodigoCargo=${props.CodigoCargo}` : "";
  const hasPalavraChave = props.PalavraChave
    ? `&PalavraChave=${props.PalavraChave}`
    : "";
  const fetchData = async () => {
    const LISTAR_DESTAQUES = `${leadsWebEnviroment}/common/destaques/detalhe/v1?${hasIdRanking}${hasCargo}&PaginaAtual=${props.PaginaAtual}&TotalItensRetorno=${props.TotalItensRetorno}${hasPalavraChave}`;
    const response = await instance.get(LISTAR_DESTAQUES);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };

  const query = useQuery({
    enabled: false,
    queryFn: fetchData,
    queryKey: [props.queryKey || "listar_destaque_detalhe"],
    refetchOnWindowFocus: false,
  });

  return query;
}
